import React, { useState, useEffect } from "react";
import { Button, Card, Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import DetailModal from "./DetailModal";
import RepairService from "../../services/RepairService";
import "./style.css";

const DonBaoduongSuachuaHT = () => {
    const [DonData, setDonData] = useState([
        {
            id: 'SA0123',
            bien_kiem_soat: "51A-12345",
            ngay_sua_chua: "2024-02-28T08:00:00Z",
            loai: "Bảo dưỡng định kỳ",
            ghi_chu: "Sửa cẩn thận",
            tram: "Trạm bảo dưỡng Quận 1",
            trang_thai: "Đã đến trạm",
            gia: 0,
            loai_xe: "Xe tải",
            tai_xe: "Lê Văn Khang(09121312)",
            phu_phi: [],
        },
        {
            id: 'BA0123',
            bien_kiem_soat: "51B-67890",
            ngay_sua_chua: "2024-02-27T14:30:00Z",
            loai: "Sửa chữa động cơ",
            tram: "Trạm bảo dưỡng Quận 7",
            tai_xe: "Lê Văn Nhật(09121312)",
            ghi_chu: "Thay cả động cơ nếu cần",
            loai_xe: "Xe khách",
            trang_thai: "Đã nhận nhiệm vụ",
            gia: 0,
            phu_phi: [],
        }
    ]);

    const [loading, setLoading] = useState(false); // Set true later if needed
    const [errorMessage, setErrorMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedDon, setSelectedDon] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await RepairService.LsBaoduongSuachua();
                console.log(response.data);
                setDonData(response.data);
            } catch (error) {
                setErrorMessage("Lỗi khi tải dữ liệu! Vui lòng thử lại.");
                console.error("Fetch error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleDetail = (don) => {
        setSelectedDon(don);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDon(null);
    };


    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
                <p>Đang tải dữ liệu...</p>
            </Container>
        );
    }
    
    return (
        <Container fluid className="mt-4 ChuyenBaoduongSuachuaComponent">
            <h2>Danh sách đơn Bảo dưỡng - Sửa chữa</h2>

            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

            <Row xs={1} sm={2} md={3} lg={3} xl={3} className="g-4">
                {DonData.map((don) => (
                    <Col key={don.id} className="mb-4">
                        <Card className="p-3 shadow-lg">
                            <Card.Body className="text-center d-flex flex-column align-items-center">
                                <Card.Title className="fw-bold">Mã Chuyến: {don.id}</Card.Title>
                                <Card.Text>Biển kiểm soát: {don.bien_kiem_soat}</Card.Text>
                                <Card.Text>
                                    Ngày sửa chữa: {new Date(don.ngay_sua_chua).toLocaleDateString()}
                                </Card.Text>
                                <Card.Text>Loại: {don.loai}</Card.Text>
                                <Card.Text>Tình trạng: {don.trang_thai}</Card.Text>
                                <Card.Text>Loại xe: {don.loai_xe}</Card.Text>
                                <Button 
                                    variant="secondary" 
                                    className="flex-grow-1 me-2"
                                    onClick={() => handleDetail(don)} 
                                >
                                    Chi tiết
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>



            {selectedDon && (
                <DetailModal
                    show={showModal}
                    handleClose={handleCloseModal}
                    selectedDon={selectedDon}
                />
            )}
        </Container>
    );
};

export default DonBaoduongSuachuaHT;
